import { Api } from '../../services/http/Api';
import { throwIfGenericApiError } from '../GenericErrors';

export type Question = {
  id: number;
  code: string;
  text: string;
  type: string;
  required: boolean;
  active: boolean;
  options: OptionsQuestion[];
  is_loop: boolean;
};

export type OptionsQuestion = {
  id: number;
  question_id: number;
  value: string;
  label: string;
  sort_order: number;
  basket_id?: number | null;
  action: 'SHOW_BASKET' | null;
};

export type QuestionPayload = {
  text: string;
  type: string;
  required: boolean;
  is_loop: boolean;
  options: QuestionOptionPayload[];
};

export type QuestionOptionPayload = {
  id?: number;
  question_id?: number;
  value: string;
  label: string;
  sort_order: number;
  basket_id: number | null;
  action: 'SHOW_BASKET' | null;
};

class QuestionsDatasource {
  protected path = 'basket/question';

  async createQuestion(payload: QuestionPayload): Promise<void> {
    const response = await new Api().post(`${this.path}/`, payload);
    throwIfGenericApiError(response);
  }

  async updateQuestion(
    questionId: number,
    payload: QuestionPayload
  ): Promise<void> {
    const response = await new Api().put(`${this.path}/${questionId}`, payload);
    throwIfGenericApiError(response);
  }

  async getById(id: number): Promise<Question> {
    const response = await new Api().fetch(`${this.path}/${id}`);
    throwIfGenericApiError(response);
    return response as Question;
  }

  async getAll(): Promise<Question[]> {
    const response = await new Api().fetch(this.path);
    throwIfGenericApiError(response);
    if (!Array.isArray(response)) {
      throw new Error('A resposta da consulta de perguntas está inválida.');
    }
    return response as Question[];
  }

  async deleteQuestion(id: number): Promise<void> {
    const response = await new Api().delete(`${this.path}/${id}`);
    throwIfGenericApiError(response);
  }
}

export const QuestionsDataSource = new QuestionsDatasource();
